import React, { useCallback } from 'react';
import styles from './TouchableComponent.module.scss';

export interface IPos {
    x: number;
    y: number;
}

interface IProps {
    children: React.ReactNode;
    onTouchEnd: () => void;
    onTouchStart: (pos: IPos) => void;
    onTouchMove: (pos: IPos) => void;
}

const TouchableComponent: React.FC<IProps> = (props) => {
    const { children, onTouchEnd, onTouchStart, onTouchMove } = props;

    const onMouseDown = useCallback((e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        onTouchStart({
            x: e.pageX,
            y: e.pageY
        })
    }, [onTouchStart]);

    const onMouseUp = useCallback(() => {
        onTouchEnd()
    }, [onTouchEnd]);

    const onMouseMove = useCallback((e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        onTouchMove({
            x: e.pageX,
            y: e.pageY
        })
    }, [onTouchMove]);

    const _onTouchStart = useCallback((e: any) => {
        if (e.touches?.length === 1) onMouseDown(e.touches[0]);
    }, [onTouchStart]);

    const _onTouchEnd = useCallback((e: any) => {
        onMouseUp();
    }, [onTouchEnd]);

    const _onTouchMove = useCallback((e: any) => {
        if (e.touches?.length === 1) onMouseMove(e.touches[0]);
    }, [onTouchMove]);

    return (
        <div
            className={styles.touchableComponent}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            onMouseLeave={onMouseUp}
            onMouseMove={onMouseMove}
            onTouchStart={_onTouchStart}
            onTouchEnd={_onTouchEnd}
            onTouchMove={_onTouchMove}
        >
            {children}
        </div>
    )
}

export default TouchableComponent;
